import '../style/css/Navbar.css';
import { useState } from 'react';
import { useScrollSection } from 'react-scroll-section';
import France from '../assets/france.svg';
import Spain from '../assets/spain.svg';
import Uk from '../assets/uk.svg';
import { motion } from 'framer-motion';
import { AiOutlineHome } from 'react-icons/ai';
import { FaReact } from 'react-icons/fa';
import { BsBriefcase } from 'react-icons/bs';
import { MdAlternateEmail } from 'react-icons/md';
import { MdTranslate } from 'react-icons/md';
import { BsArrow90DegDown } from 'react-icons/bs';
import { BsArrow90DegUp } from 'react-icons/bs';
import {BsPlayBtn} from "react-icons/bs";
import { useTranslation } from 'react-i18next';

function Navbar({ handleMenuOpen, menuOpen }) {
  const home = useScrollSection('home');
  const technologies = useScrollSection('technologies');
  const works = useScrollSection('works');
  const contact = useScrollSection('contact');
  const featured = useScrollSection("featured");
  const [showLanguage, setShowLanguage] = useState(false);

  const { i18n } = useTranslation();

  const menuLang = [{ id: 'fr' }, { id: 'en' }, { id: 'es' }];

  return (
    <>
      {/* ---------------------Sidebar */}
      <motion.div
        initial={{ x: '-30%', opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        className={showLanguage ? "navigation show-lang" :"navigation"}
      >
        <li onClick={home.onClick} selected={home.selected}>
          <AiOutlineHome
            className={home.selected ? 'icon active-nav' : 'icon'}
          />
        </li>

        <li onClick={featured.onClick} selected={featured.selected}>
          <BsPlayBtn
            className={featured.selected ? 'icon active-nav' : 'icon'}
          />
        </li>

        <li onClick={technologies.onClick} selected={technologies.selected}>
          <FaReact
            className={technologies.selected ? 'icon active-nav' : 'icon'}
          />
        </li>

        <li onClick={works.onClick} selected={works.selected}>
          <BsBriefcase
            className={works.selected ? 'icon active-nav' : 'icon'}
          />
        </li>

        <li onClick={contact.onClick} selected={contact.selected}>
          <MdAlternateEmail
            className={contact.selected ? 'icon active-nav' : 'icon'}
          />
        </li>

        {/* ---------------------Lang menu */}
        <li
          className='lang-menu'
          onMouseEnter={() => setShowLanguage(true)}
          onMouseLeave={() => setShowLanguage(false)}
        >
          {showLanguage ? (
            <BsArrow90DegDown className='icon' />
          ) : (
            <MdTranslate className='icon' />
          )}

          {showLanguage &&
            menuLang.map((item) => (
              <div className='toggle-container' key={item.id}>
                <input
                  type='radio'
                  className='toggle'
                  id={item.id}
                  checked={item.id === i18n.resolvedLanguage}
                  onChange={() => i18n.changeLanguage(item.id)}
                />
                <label className='label' htmlFor={item.id}>
                  <img
                    src={
                      item.id === 'fr' ? France : item.id === 'es' ? Spain : Uk
                    }
                    className='flag'
                    alt="flag"
                  />
                </label>
              </div>
            ))}
        </li>
      </motion.div>

      {/* ---------------------Responsive */}

      {/* ---------------------Hamburger menu */}
      <motion.div
        initial={{ x: '-50%' }}
        animate={{ x: 0 }}
        transition={{ stiffness: 60 }}
        onClick={() => {
          handleMenuOpen()
        }}
        className={
          menuOpen ? 'hamburger-menu active-hamburger' : 'hamburger-menu'
        }
      >
        <div></div>
      </motion.div>

      {/* ---------------------Language menu */}
      {menuOpen && (
        <motion.div
          onClick={() => setShowLanguage(!showLanguage)}
          className={
            showLanguage ? 'responsive-lang active' : 'responsive-lang'
          }
        >
          {showLanguage ? <BsArrow90DegUp /> : <MdTranslate />}


            {showLanguage && 
          <div className='grid'>
              {menuLang.map((item) => (
                <div key={item.id} onClick={() => i18n.changeLanguage(item.id)}>
                  <img    src={
                      item.id === 'fr' ? France : item.id === 'es' ? Spain : Uk
                    } />
                </div>
              ))}
          </div>
      }
        </motion.div>
      )}
    </>
  );
}

export default Navbar;
